// @flow
import { ConfigurableAttributes } from '../../flowtypes/product';
import { fromNullable } from 'fp-ts/lib/Option';
import { updatePrice, setAvailableProducts } from './configuration';

export type $AttributesState = ConfigurableAttributes;

const initialState = [];

/* Constants */
const SET_ATTRIBUTE = 'PRODUCT/CONFIGURABLE_ATTRIBUTES/SET_ATTRIBUTE';
const SET_ATTRIBUTE_ERROR = 'PRODUCT/CONFIGURABLE_ATTRIBUTES/SET_ATTRIBUTE_ERROR';
export const CART_STATUS_FAILURE = 'CART_FAILURE';
export const CART_STATUS_SUCCESS = 'CART_SUCCESS';
export const CART_STATUS_PROCESSING = 'CART_PROCESSING';

/* Actions */
const setAttributeValueAction = (key: String, value: ?String) => ({
  type: SET_ATTRIBUTE,
  key,
  value,
});

export const setAttributeValue = (key: String, value: ?String) => (dispatch: Function, getState: Function) => {
  dispatch(setAttributeValueAction(key, value));
  fromNullable(getState().configuration)
    .map(() => {
      dispatch(updatePrice());
      dispatch(setAvailableProducts());
      return null;
    }).getOrElse(() => {});
};

export const setAttributeError = (attributeId: String, error: ?String) => ({
  type: SET_ATTRIBUTE_ERROR,
  attributeId,
  error,
});

/* Reducer */
export default function reducer(state: ConfigurableAttributes = initialState, action: Object) {
  switch (action.type) {
    case SET_ATTRIBUTE: {
      const { key, value } = action;
      return [
        ...state.map(attr => ({
          ...attr,
          ...(attr.id === key ? {
            value,
          } : {}),
        })),
      ];
    }
    case SET_ATTRIBUTE_ERROR: {
      const { attributeId, error } = action;
      return [
        ...state.map(attr => ({
          ...attr,
          ...(attr.id === attributeId ? {
            error,
          } : {}),
        })),
      ];
    }
    default: {
      return state;
    }
  }
}

/* Selectors */
export const attributesSelector = (state: Object) => state.attributes;


// WEBPACK FOOTER //
// ./src/store/modules/attributes.js